import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool
import { templateConfig, reduxTemplateCofig } from './config'
let { WizTooltip, WizBrowserExport } = component_tool
import './index.less'

class IntegrationCounseling extends WizContainer {

    componentName = 'IntegrationCounseling'

    constructor(props) {
        super(props)
        this.state = {
            remind: [],
            AddTimestamp: new Date().getTime()
        }
    }

    _renderRemind = () => {
        let { remind } = this.state
        if (remind && remind.length) {
            let title = []
            remind.forEach(item => {
                title.push(<div>{item}</div>)
            })
            return (
                <div className='integration-counseling-remind'>
                    <WizTooltip placement='left' title={title} overlayStyle={{ maxWidth: 500 }}>
                        <img className='icon' src={constants.files.sys_counseling_tips} />
                    </WizTooltip>
                </div>
            )
        } else {
            return null
        }
    }

    _handleRevoke(nextProps, nextState, key) {
        let o = nextProps[key]
        if (o['success']) {
            wizNotice.success(o['msg'])
            return true
        } else {
            wizNotice.error(o['msg'])
            return false
        }
    }

    _handleRemind = (nextProps, nextState, key) => {
        let o = nextProps[key]
        if (o.success) {
            this.setState({ remind: o.data })
            return true
        }
    }

    _handleFile(nextProps, nextState, key) {
        let { code, data, msg } = nextProps[key]
        if (code === 1) {
            let columns = [{
                headerName: '',
                width: 30,
                field: 'rowIndex',
                hidden: true,
                suppressMovable: true,
                cellStyle: {
                    textAlign: 'center',
                    padding: '5px 0',
                    color: '#595959',
                    backgroundColor: '#f0f0f0',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '500',
                    boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
                }
            }, {
                headerName: '经销商名称',
                field: 'orgName',
                width: 40,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '经销商简称',
                field: 'shortName',
                width: 20,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '销售代码',
                field: 'preSalesNumber',
                width: 20,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '售后代码',
                field: 'afterSalesNumber',
                width: 20,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '品牌',
                field: 'brandName',
                width: 20,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '辅导模块',
                field: 'moduleType',
                width: 20,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '上线日期',
                field: 'onlineTime',
                width: 30,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '辅导老师',
                field: 'teacherList',
                width: 30,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '当前流程',
                field: 'flowStates',
                width: 30,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '状态',
                field: 'status',
                width: 20,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }]

            let rows = data.map(item => {
                let { moduleType, teacherList, flowStates, status } = item
                item.moduleType = moduleType === 0 ? '销售' : '售后'
                item.teacherList = teacherList.map(teacher => teacher.fullName).join(',')
                item.flowStates = flowStates.map(flowState => {
                    switch (flowState) {
                        case 0:
                            return '上线通知'
                        case 1:
                            return '前期介入'
                        case 2:
                            return '预审核'
                        case 3:
                            return '辅导'
                        case 4:
                            return '跟踪'
                        case 5:
                            return '检核'
                        default:
                            return ''
                    }
                }).join(',')
                switch (status) {
                    case 0:
                        item.status = '进行中'
                        break
                    case 1:
                        item.status = '已完成'
                        break
                    case 2:
                        item.status = '已撤销'
                        break
                    default:
                        item.status = ''
                }
                return item
            })

            WizBrowserExport({
                title: '融入辅导',
                sheetName: '融入辅导',
                columns: columns.filter((_, index) => index),
                rows,
                filename: '融入辅导.xlsx',
            })
            return true
        } else {
            wizNotice.error(msg)
            return false
        }
    }

    _render() {
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig: templateConfig(this),
            apiDataFormat: {
                remind: this._handleRemind,
                revoke: this._handleRevoke,
                export: this._handleFile
            },
        })
        return <WizReduxTemplate {..._reduxTemplateCofig} />
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
}

export default connect(mapStateToProps)(IntegrationCounseling)
